import { HttpStatusCode } from "axios";
import BaseResponse from "../../infrastructure/model/base/BaseResponse";

export type StatusHandler<T> = {
  onSuccess: () => void,
  onSuccessWithData: (res: Required<T>) => void,
  onDefaultError: () => void,
  onNotfound: () => void,
  onError:(message?: string) => void
  // TODO: add more error
}

export default class HttpUtils {
  public static isSuccess<T>(response: BaseResponse<T>): response is Required<BaseResponse<T>> {
    return response.code === HttpStatusCode.Ok && response.data != undefined;
  }
  
  public static handleResponse<T>(
    response: BaseResponse<T>,
    handler: Partial<StatusHandler<BaseResponse<T>>>
  ) {
    switch (response.code) {
      case HttpStatusCode.Ok: {
        if (HttpUtils.isSuccess(response) && handler.onSuccessWithData) {
          handler.onSuccessWithData(response);
        } else {
          handler.onSuccess?.();
        }
        break;
      }
      
      case HttpStatusCode.NotFound: {
        if (handler.onNotfound) {
          handler.onNotfound();
        }
        handler.onDefaultError?.();
        break;
      }
      case HttpStatusCode.InternalServerError: {
        if(handler.onError) {
          handler.onError();
        }
        handler.onDefaultError?.();
        break;
      }
      
      default: {
        handler.onDefaultError?.();
      }
    }
  }
}
